/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Draft_Total_DriftInputs */

const vi_einvoice_error_draft_total_drift = /** @type {(inputs: Einvoice_Error_Draft_Total_DriftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng tiền đơn hàng chưa khớp với các mặt hàng. Nhờ kế toán kiểm tra lại đơn trước khi gửi MISA.`)
};

/**

* @param {Einvoice_Error_Draft_Total_DriftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_draft_total_drift = /** @type {((inputs?: Einvoice_Error_Draft_Total_DriftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Draft_Total_DriftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_draft_total_drift(inputs)
});